'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var NitroHeading = function NitroHeading(props) {
  var after = props.after,
      before = props.before,
      label = props.label,
      labelHighlight = props.labelHighlight,
      other = _objectWithoutProperties(props, ['after', 'before', 'label', 'labelHighlight']);

  return _react2.default.createElement(
    _styles.Heading,
    other,
    before,
    label,
    labelHighlight && _react2.default.createElement(
      _styles.HightlightLabel,
      null,
      labelHighlight
    ),
    after
  );
};

NitroHeading.propTypes = {
  align: _propTypes2.default.string,
  before: _propTypes2.default.node,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string.isRequired,
  labelHightlight: _propTypes2.default.string,
  noMargin: _propTypes2.default.bool,
  opacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  variant: _propTypes2.default.string
};

NitroHeading.defaultProps = {
  align: 'left',
  opacity: 1,
  size: 1
};

exports.default = NitroHeading;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-heading/NitroHeading.js
// module id = 2911
// module chunks = 4